export default "__VITE_ASSET__BjycHIhR__"